import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi, timeAgo} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import moment from 'moment';
import momenttz from 'moment-timezone';


import DJAreaSideMenu from './sidemenu';
import Genres from '../components/genres/genres';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';


export default class Admin extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			emptySets: [],
			oldAccounts: [],
		};
		this.getIndex = this.getIndex.bind(this);
		this.scheduleCancel = this.scheduleCancel.bind(this);
		this.scheduleDelete = this.scheduleDelete.bind(this);
		this.resetAccount = this.resetAccount.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		await this.getIndex();
	}

	componentWillUnmount() {
	}

	async getIndex() {
		let params = new URLSearchParams();
		const x = await postApi('/api/v2/admin/index', params);
		console.log(x.data);
		if( x.status === 200 ) {
			this.setState({status: true, emptySets: x.data.emptySets, oldAccounts: x.data.oldAccounts});
		}
	}

	async scheduleCancel(id) {
		if( window.confirm("Are you sure you wisth to cancel this set?") ) {
			let params = new URLSearchParams();
			params.append('id', id);
			const x = await putApi('/api/v2/admin/schedulecancel', params);
			if( x.status === 200 ) {
				await this.getIndex();
			}
		}
	}
	
	async scheduleDelete(id) {
		if( window.confirm("Are you sure you wish to delete this set?") ) {
			let params = new URLSearchParams();
			params.append('id', id);
			const x = await deleteApi('/api/v2/admin/scheduledelete', params);
			if( x.status === 200 ) {
				await this.getIndex();
			}
		}
	}

	async resetAccount(id) {
		console.log(id);

		if( window.confirm("Are you sure you wish to reset this DJ back to member?") ) {
			let params = new URLSearchParams();
			params.append('id', id);
			const x = await putApi('/api/v2/admin/removedj', params);
			if( x.status === 200 ) {
				await this.getIndex();
			}
		}

	}

	render() {
		
		let _date = Math.floor(Date.now()/1000);
		let timezone_non = new Date().getTimezoneOffset()*-1;//.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;
		const emptySets = 
      Object.keys(this.state.emptySets).map((e,i) => {
        return (
					<React.Fragment key={i}>
						<div className="col-12" /*onMouseEnter={()=>this.schedulehover(e)} onMouseLeave={()=>this.schedulehover(0)}*/>
							<div className={`p-schedule-event ${this.state.emptySets[e].cancelled===1&&this.state.emptySets[e].dummy===0?'p-schedule-event-cancelled':''}`}>
								<Row>
									<div className="text-vcenter" style={{width:180}}>
										<div>
											{moment(this.state.emptySets[e].start*1000).format("HH:mm - ")}
											{moment(this.state.emptySets[e].end*1000).format("HH:mm")}

											{timezone_non!==timezone_uk &&
												<>
													{/*&nbsp;{DateTime.local().toFormat('ZZZZ')}*/}
													<br />
													<small>({moment((this.state.emptySets[e].start+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} - {moment((this.state.emptySets[e].end+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} UK)</small>
												</>
											}
											<br/>{moment((this.state.emptySets[e].start+(timezone_uk-timezone_non)*60)*1000).format("DD/MM/YYYY")}

											{/**/}
										</div>
									</div>
									<div className="p-schedule-event-image">
										<img src={`https://mix365.co.uk/${this.state.emptySets[e].avatar}`} width="84" height="84" alt="profile avatar" />
									</div>
									<Col className="p-schedule-event-right text-vertical">
										<div>
											<Link to={this.state.emptySets[e].username===null?'#':`/${this.state.emptySets[e].username.toLowerCase().replaceAll(' ','_')}`} className="pb-4">
												{this.state.emptySets[e].djtitle?this.state.emptySets[e].djtitle:this.state.emptySets[e].title?this.state.emptySets[e].title:this.state.emptySets[e].username}
											</Link>{this.state.emptySets[e].cancelled===1 && this.state.emptySets[e].dummy===0 && <>&nbsp;&nbsp;Cancelled</>}<br />
											{this.state.emptySets[e].description && <><span className="p-schedule-description">{this.state.emptySets[e].description}</span></>}
											<Genres genres={ this.state.emptySets[e].genres.length > 0 ? this.state.emptySets[e].genres : this.state.emptySets[e].start>_date ? this.state.emptySets[e].defaultgenres : [] } />
										</div>
									</Col>
									<div style={{width: 240}} className="text-vcenter">
										<div>
											<small>schedule: {this.state.emptySets[e].id}, uid: {this.state.emptySets[e].uid}&nbsp;&nbsp;</small><br/>
												<ButtonGroup size="sm">
													<Button onClick={()=>this.scheduleCancel(this.state.emptySets[e].id)}><FontAwesomeIcon icon="bars" />&nbsp;Cancel</Button>
													{/*<Button onClick={()=>this.scheduleDelete(this.state.emptySets[e].id)}><FontAwesomeIcon icon="trash" />&nbsp;Delete</Button>*/}
												</ButtonGroup>
											
										</div>
									</div>
								</Row>
							</div>
						</div>
					</React.Fragment>
        )
      })
		const oldAccounts = 
      Object.keys(this.state.oldAccounts).map((e,i) => {
        return (
					<React.Fragment key={i}>
						{this.state.oldAccounts[e].delete === 1 &&
							<Col key={i} xs={12} >
								<Row className="py-1 gx-0">
									<div style={{width: 80}}><img src={`https://mix365.co.uk${this.state.oldAccounts[e].avatar}`}  alt="Profile Avatar" className="djaccounts-avatar" /></div>
									<Col className="text-vertical">{this.state.oldAccounts[e].username}<br />{this.state.oldAccounts[e].email}</Col>
									<Col className="text-vertical">{moment(this.state.oldAccounts[e].lastconnect*1000).format("ddd Do MMM ~ HH:mm:ss")}</Col>
									<Col className="text-vertical">{timeAgo(parseInt(this.state.oldAccounts[e].lastplayed))}</Col>
									<Col className="text-vertical"><Button size="sm" onClick={()=>{this.resetAccount(this.state.oldAccounts[e].id)}}>Remove DJ Access</Button></Col>
								</Row>
							</Col>
						}
					</React.Fragment>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col>
					{this.state.status &&
						<>
							<Row>
								<Col>
									<div className="card bg-dark">
										<div className="card-header">
											<h3 className="card-title">Empty Sets</h3>
										</div>
										<div className="card-body">
											{Object.keys(this.state.emptySets).length > 0 ?
												<>
													Display empty sets that have not been filled
													{emptySets}
												</>
											:
												<>
													There are no empty sets to display
												</>
											}
										</div>
									</div>
								</Col>
							</Row>

							<Row>
								<Col>
									<div className="card bg-dark">
										<div className="card-header">
											<h3 className="card-title">Level/Rank unmet</h3>
										</div>
										<div className="card-body">
											Display members ranks that are no in line, this will have to come back to.
										</div>
									</div>
								</Col>
							</Row>

							<Row>
								<Col>
									<div className="card bg-dark">
										<div className="card-header">
											<h3 className="card-title">Old Accounts</h3>
										</div>
										<div className="card-body">
											DJ's that no longer play, not played or over 90 days:
											<Row className="gx-0">
												<div className="" style={{width: 80}}>
												</div>
												<Col>Account</Col>
												<Col>Last Logged In</Col>
												<Col>Last Played</Col>
												<Col>Remove Account</Col>
											</Row>
											<Row className="gx-0">
												{oldAccounts}
											</Row>
										</div>
									</div>
								</Col>
							</Row>
						</>
					}
				</Col>
			</Row>
		);
	}
}
